import { getValueAtPath } from './values';
import type { UiSchemaRule } from './types';

/**
 * Conditional DISPLAY only — never validation (docs/forms-schema.md's "two
 * mechanisms" split, `app.mainlinepro` API repo). A field a rule hides is
 * still validated by the JSON Schema exactly as if it were shown; hiding it
 * here must never be read as "and therefore not required".
 *
 * A field with no matching rule is always visible — `rules` is an allow-list
 * of exceptions, not a whitelist of what may render.
 */
export function isFieldVisible(rules: UiSchemaRule[] | undefined, fieldPath: string, values: unknown): boolean {
  const rule = (rules ?? []).find((r) => r.field === fieldPath);
  if (!rule) {
    return true;
  }

  return getValueAtPath(values, rule.showWhen.field) === rule.showWhen.equals;
}
